// Firebase-Konfiguration
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database'; // Realtime Database
import { getStorage, connectStorageEmulator } from 'firebase/storage';   // Firebase Storage

const firebaseConfig = {
  apiKey: "AIzaSyBhyFgD2QvK25GeXCUiPfMxEbi4RGvnFVs",
  authDomain: "northstar-a53fd.firebaseapp.com",
  projectId: "northstar-a53fd",
  storageBucket: 'northstar-a53fd.appspot.com',
  messagingSenderId: "264123368311",
  appId: "1:264123368311:web:92b964117eb16606dc9772",
  databaseURL: 'https://northstar-a53fd-default-rtdb.europe-west1.firebasedatabase.app', // Wichtig für Realtime DB
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Instanzen exportieren
export const auth = getAuth(app);
export const db = getDatabase(app);    // Realtime Database exportieren
export const storage = getStorage(app); // Storage exportieren

// Erhöhe die maximale Wiederholungszeit für Uploads
storage.maxUploadRetryTime = 30000;
storage.maxOperationRetryTime = 30000;

// Verwende Emulatoren für lokale Entwicklung
const useEmulators = false; // Auf true setzen, um Emulatoren zu verwenden

if (useEmulators && process.env.NODE_ENV === 'development') {
  // Verbinde mit lokalen Emulatoren
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectDatabaseEmulator(db, 'localhost', 9000);
  connectStorageEmulator(storage, 'localhost', 9199);
  console.log('Using Firebase Emulators');
}

export default app; 